import zsmLayout from '@/zsm-layout'

const marketRouter = {
  path: '/market',
  component: zsmLayout,
  name: 'market',
  redirect: '/market/coupon',
  children: [
    {
      path: '/market',
      component: () => import('@/view/market/index'),
      name: 'coupon',
      children: [

        {
          meta: {
            title: '活动订单记录'
          },
          path: '/market/flash-sale-detail',
          component: () => import('@/view/market/sale/flash-sale-detail'),
          name: 'flash-sale',
          hidden: true
        },
        {
          meta: {
            title: '限时抢购'
          },
          path: '/market/flash-sale',
          component: () => import('@/view/market/sale/flash-sale'),
          name: 'flash-sale',
          hidden: true
        },
        {
          meta: {
            title: '优惠券列表'
          },
          path: '/market/coupon',
          component: () => import('@/view/market/coupon/index/list'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '优惠券领取记录'
          },
          path: '/market/coupon-detail',
          component: () => import('@/view/market/coupon/index/detail'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '添加优惠券'
          },
          path: '/market/add-coupon',
          component: () => import('@/view/market/coupon/index/add'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '直播间优惠券'
          },
          path: '/market/coupon/live',
          component: () => import('@/view/market/coupon/live/add'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '分享优惠券'
          },
          path: '/market/coupon/share',
          component: () => import('@/view/market/coupon/share/add'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '分享优惠券详情'
          },
          path: '/market/coupon/share-detail',
          component: () => import('@/view/market/coupon/share/detail'),
          name: 'coupon',
          hidden: true
        },
        
        {
          meta: {
            title: '直播集合页'
          },
          path: '/market/live',
          component: () => import('@/view/market/mount/live'),
          name: 'coupon',
          hidden: true
        },

        {
          meta: {
            title: '直播集合页'
          },
          path: '/market/live-detail',
          component: () => import('@/view/market/mount/live-detail'),
          name: 'coupon',
          hidden: true
        },

        {
          meta: {
            title: '课程套餐'
          },
          path: '/market/givetmeal',
          component: () => import('@/view/market/give/givetmeal.vue'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '课程套餐'
          },
          path: '/market/addgivetmeal',
          component: () => import('@/view/market/give/add-givetmeal.vue'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '课程套餐'
          },
          path: '/market/givetmeal-detail',
          component: () => import('@/view/market/give/givetmeal-detail.vue'),
          name: 'coupon',
          hidden: true
        },
        {
          meta: {
            title: '附赠实物'
          },
          path: '/market/object',
          component: () => import('@/view/market/give/object.vue'),
          name: 'object',
          hidden: true
        }

      ]
    }
  ]
}

export default marketRouter
